import React from 'react';
import {UploadedFile, UploadedFileTypeEnum} from 'interfaces/models';
import {Table} from 'reactstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import styles from './UploadedFileList.module.css';
import 'font-awesome/css/font-awesome.css';

interface Props {
    uploadedFiles: UploadedFile[],
    handleCrop: (fileId: number) => void
}

const UploadedFileList: React.FC<Props> = ({uploadedFiles, handleCrop}) => {
    const renderTableHeader = () => {
        return <thead>
            <tr>
                <th>&nbsp;</th>
                <th>Name</th>
                <th>CDN Url</th>
                <th>Actions</th>
                <th>Status</th>
                <th>Upload date</th>
            </tr>
        </thead>;
    }
    
    const renderTableContent = () => {
        return <tbody>
            {!!uploadedFiles && !!uploadedFiles.length && uploadedFiles.map((x, i) => renderTableRow(x, i))}
        </tbody>;
    }
    
    const renderTableRow = (file: UploadedFile, key: number) => {
        const renderThumbnail = () => 
            <img className={styles.imageThumbnail} 
                 src={file.thumbnailImageUrl || file.cdnUrl} 
                 alt={file.fileName} />;
        
        const renderCopyUrlButton = () => {
            const url = file.largeImageUrl || file.cdnUrl;
            return <>
                <CopyToClipboard text={url}>
                    <span className={styles.actionButton}>
                        <i className="fa fa-clipboard" aria-hidden="true"/> Copy
                    </span>
                </CopyToClipboard>
            </>;
        }
        
        const renderCropButton = () => {
            if (file.fileType !== UploadedFileTypeEnum.Image || !file.imageData) return null;
            return <span onClick={() => handleCrop(file.id)} className={styles.actionButton}>
                <i className="fa fa-crop" aria-hidden="true"/> Crop
            </span>;
        }
        
        return <tr key={key}>
            <td>{file.fileType === UploadedFileTypeEnum.Image ? renderThumbnail() : null}</td>
            <td><a href={file.cdnUrl} target="_blank" rel="noopener noreferrer">{file.fileName}</a></td>
            <td>{renderCopyUrlButton()}</td>
            <td>{renderCropButton()}</td>
            <td>{file.fileStatus}</td>
            <td>{file.uploadDate}</td>
        </tr>;
    }
    
    return <Table>
        {renderTableHeader()}
        {renderTableContent()}
    </Table>;
}

export default UploadedFileList;